import React, { useContext, useState } from "react";
import Button from "~/components/parts/Button";
import { SubscriptionContext, SubscriptionDispatchContext } from "..";
import useMutation from "~/hooks/useMutation";

const Generate = () => {
  const { school = {} } = useContext(SubscriptionContext);
  const dispatch = useContext(SubscriptionDispatchContext);

  const [generated, setGenerated] = useState(false);

  const {
    isLoading,
    error,
    mutationFn: generateInvoice,
  } = useMutation("/api/subscription/intent/default", {
    method: "POST",
    headers: { "Content-type": "application/json" },
    body: JSON.stringify({ sid: school.sid }),
  });

  const handleGenerateInvoice = async () => {
    const { data, isSuccess } = await generateInvoice();
    if (isSuccess) {
      dispatch({ type: "add_invoice", payload: data });
      setGenerated(true);
    }
  };

  return (
    <>
      <p className="m-0 max-w-[600px] text-sm font-semibold text-slate-600">
        You have selected a 12-month subscription for £600 (+ VAT if
        applicable).
      </p>
      <Button
        className="max-w-[350px] bg-blue-500 p-2 text-sm text-white shadow-sm hover:bg-blue-500 disabled:bg-blue-200 disabled:text-white disabled:shadow-none"
        disabled={isLoading || generated}
        onClick={handleGenerateInvoice}
      >
        {isLoading
          ? "Loading"
          : generated
            ? "Invoiced generated"
            : "Generate invoice"}
      </Button>
      {generated && (
        <p className="m-0 max-w-[600px] text-sm font-semibold text-slate-600">
          Please download from the list below and follow the payment
          instructions on the invoice.
        </p>
      )}
      {error && (
        <p className="m-0 max-w-[600px] text-sm font-semibold text-red-800">
          There was an error generating your invoice.
        </p>
      )}
    </>
  );
};

export default Generate;
